<template>
  <div v-if="false" id="page-wrap">
    <div class="container-fluid">
      <div class="container">
        <div class="content-wrapper">
          <div class="content" v-if="!isApplySuccess">
            <ul>
              <li @click="goToApply">临时账号申请</li>
              <li class="active">临时账号延期申请</li>
            </ul>
            <div class="content-header">
              <img src="@/assets/images/apply_header.png"  alt="">
              <div class="content-header_item item_1">
                <div class="content-header_item_title">1.填写临时账号延期申请表</div>
                <div class="content-header_item_content">填写账号、有效期、延期原因说明</div>
              </div>
              <div class="content-header_item item_2">
                <div class="content-header_item_title">2.导师/校内联系人审批</div>
                <div class="content-header_item_content">通过校内邮箱登陆审批</div>
              </div>
              <div class="content-header_item item_3">
                <div class="content-header_item_title">3.管理员延期临时账号</div>
                <div class="content-header_item_content">发送账号延期通知</div>
              </div>
              <div class="content-header_item item_4">
                <div class="content-header_item_title">4.延期成功</div>
                <div class="content-header_item_content">申请人正常登录账号</div>
              </div>
            </div>
            <div class="form apply-form">
              <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="账号"
                    v-model.trim="form.username"
                    name="username"
                    data-vv-as="账号 "
                    v-validate="{ required: true }"
                    @blur="searchTempAccount"
                  />
                <span class="help-block" v-show="errors.has('username')">{{
                  errors.first("username")
                }}</span>
              </div>

              <div class="form-group">
                <div class="radiobox">
                  <div class="radio i-checks">
                    <label>
                      类型：
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        style="width:100%;"
                        name="account_type"
                        type="radio"
                        v-model="form.account_type"
                        value="1"
                        disabled
                      />
                      <i></i>
                      准研究生用户
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        style="width:100%;"
                        name="account_type"
                        type="radio"
                        v-model="form.account_type"
                        value="2"
                        disabled
                      />
                      <i></i>
                      校外合作用户
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="姓名"
                  type="text"
                  v-model.trim="form.name"
                  name="name"
                  disabled
                />
              </div>

              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="邮箱"
                  type="text"
                  v-model.trim="form.email"
                  name="email"
                  disabled
                />
              </div>

              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="手机号"
                  type="text"
                  v-model.trim="form.mobile"
                  name="mobile"
                  disabled
                />
              </div>

              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="验证码"
                    v-model.trim="form.sms_code"
                    name="sms_code"
                    data-vv-as="验证码 "
                    v-validate="{ required: true, min: 4, max: 8 }"
                  />
                  <span class="input-group-btn">
                    <button
                      class="btn btn-link"
                      type="button"
                      :disabled="smsSending || isSmsSendingRemainimg"
                      @click="sendMobileCodeFromDelay"
                    >
                      {{ isSmsSendingRemainimg ? '剩余 ' + smsSendingRemainimgTime + ' 秒' : '发送验证码' }}
                    </button>
                  </span>
                </div>
                <span class="help-block" v-show="errors.has('sms_code')">{{
                  errors.first("sms_code")
                }}</span>
              </div>

              <div class="form-group">
                <div class="radiobox">
                  <div class="radio i-checks">
                    <label>
                      有效期：
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="delay_month"
                        type="radio"
                        v-model="form.delay_month"
                        value="3"
                      />
                      <i></i>
                      3个月
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="delay_month"
                        type="radio"
                        v-model="form.delay_month"
                        value="6"
                      />
                      <i></i>
                      6个月
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="delay_month"
                        type="radio"
                        v-model="form.delay_month"
                        value="9"
                      />
                      <i></i>
                      9个月
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="delay_month"
                        type="radio"
                        v-model="form.delay_month"
                        value="12"
                      />
                      <i></i>
                      12个月
                    </label>
                  </div>
                </div>
                <span class="help-block" v-show="errors.has('delay_month')">{{
                  errors.first("delay_month")
                }}</span>
              </div>
              
              <div class="form-group">
                <input
                  class="form-control"
                  :placeholder="form.account_type==1 ? '导师姓名' : '联系人'"
                  type="text"
                  v-model.trim="form.link_name"
                  name="link_name"
                  disabled
                />
              </div>
              
              <div class="form-group form-text">
                <input
                  class="form-control"
                  :placeholder="form.account_type==1 ? '导师邮箱' : '联系人邮箱'"
                  type="text"
                  v-model.trim="form.link_email"
                  name="link_email"
                  disabled
                />
                <p class="text-msg" style="padding-top: 5px;">临时账号延期申请后，申请信息将邮件发送至{{ form.account_type==1 ? '导师邮箱' : '联系人邮箱' }}邮箱</p>
              </div>

              <div class="form-group">
                <textarea
                  class="form-control"
                  placeholder="延期原因"
                  style="resize: vertical"
                  rows="4"
                  v-model.trim="form.delay_reason"
                  name="delay_reason"
                  data-vv-as="延期原因 "
                  v-validate="{ required: true, max: 255 }"
                ></textarea>
                <span class="help-block custom-help-block-1" v-show="errors.has('delay_reason')">{{
                  errors.first("delay_reason")
                }}</span>
              </div>

              <div class="form-group">
                <button
                  class="btn btn-primary btn-submit"
                  type="button"
                  :disabled="loading"
                  @click="delayTempAccount"
                >
                  <span>{{ loading ? "正在提交..." : "提交" }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="success" v-else>
            <img src="@/assets/images/success.svg" />
            <p class="success-title">临时账号延期申请已提交</p>
            <p class="success-content">在您提交临时账号延期申请后，我们将向您提供的{{ form.account_type==1 ? '导师邮箱' : '联系人邮箱' }}发送一封审核邮件。您可以与您的{{ form.account_type==1 ? '导师' : '联系人' }}取得联系，以便他们进行审核。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { delayTempAccount, sendMobileCodeFromDelay, searchTempAccount } from "@/api/user/user";
export default {
  name: "DelayTempAccount",
  data() {
    return {
      isApplySuccess: false,
      loading: false,
      smsSending: false,
      searching: false,
      isSmsSendingRemainimg: false,
      smsSendingRemainimgTime: 60,
      form: {
        username: '',
        account_type: "1", // 类型
        name: '', // 姓名
        email: "", // 邮箱
        mobile: "", // 手机号
        sms_code: "", // 验证码
        delay_reason: "", // 延期原因
        link_name: "", // 导师姓名 / 联系人姓名
        link_email: "", // 导师邮箱 / 联系人邮箱
        delay_month: '3', // 有效期
      }
    }
  },
  created() {
    this.$store.commit("SET_THEME", "临时账号延期申请");
  },
  methods: {
    // 查询临时账号
    searchTempAccount () {
      if (!this.form.username) {
        this.errors.add({
          field: "username",
          msg: "请填写账号",
        });
        return false;
      }
      this.searching = true
      searchTempAccount({
        username: this.form.username
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.form.account_type = res.entity.account_type
            this.form.name = res.entity.real_name
            this.form.email = res.entity.email
            this.form.mobile = res.entity.mobile
            this.form.link_name = res.entity.link_name
            this.form.link_email = res.entity.link_email
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        }).finally(() => {
          this.searching = false;
        });
    },
    goToApply() {
      this.$router.push({name:'applyTempAccount'})
    },
    handleChangeAccountType() {
      this.$validator.reset();
      this.errors.remove("file")
    },
    // 发送短信验证码
    sendMobileCodeFromDelay() {
      if (!this.form.mobile) {
        this.errors.add({
          field: "mobile",
          msg: "请填写手机号",
        });
        return false;
      }
      this.smsSending = true
      sendMobileCodeFromDelay({
        mobile: this.form.mobile
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });

            // 发送成功后进入倒计时
            this.isSmsSendingRemainimg = true
            this.setEmailSendingRemainimgTime()
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        }).finally(() => {
          this.smsSending = false;
        });
    },
    // 验证码倒计时
    setEmailSendingRemainimgTime() {
      const timer = setInterval(() => {
        if (this.smsSendingRemainimgTime > 1) {
          this.smsSendingRemainimgTime--;
        } else {
          clearInterval(timer)
          this.isSmsSendingRemainimg = false
          this.smsSendingRemainimgTime = 60
        }
      }, 1000);
    },
    // 提交
    delayTempAccount() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          const formData = new FormData();
          formData.append("username", this.form.username);
          formData.append("sms_code", this.form.sms_code);
          formData.append("delay_month", this.form.delay_month);
          formData.append("delay_reason", this.form.delay_reason);
          delayTempAccount(formData)
            .then((res) => {
              if (res.status_code === 200) {
                this.isApplySuccess = true
                // this.form = {
                //   username: '',
                //   account_type: "1", // 类型
                //   name: '', // 姓名
                //   email: "", // 邮箱
                //   mobile: "", // 手机号
                //   sms_code: "", // 验证码
                //   delay_reason: "", // 延期原因
                //   link_name: "", // 导师姓名 / 联系人姓名
                //   link_email: "", // 导师邮箱 / 联系人邮箱
                //   delay_month: '3', // 有效期
                // }
                // this.$message({
                //   type: "success",
                //   message: res.message,
                // });
                // this.$nextTick(() => {
                //   this.$validator.reset();
                // });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            }).finally(() => {
              this.loading = false;
              this.isSmsSendingRemainimg = false
              this.smsSendingRemainimgTime = 60
            });
        }
      });
    },
  }
};
</script>

<style scoped>
  .i-checks input[disabled]+i:before{
    background-color: #ddd;
  }
  .i-checks input[disabled]+i:before, fieldset[disabled] .i-checks input+i:before {
    color: #fff;
  }
  .i-checks input[disabled]+i, fieldset[disabled] .i-checks input+i {
    border-color: #ddd;
  }
  .i-checks input:checked+i:before {
    border-radius: 9px !important;
  }
  .i-checks input[type="radio"]+i {
    border-radius: 100% !important;
  }
  @media (max-width: 1200px) {
    .content-wrapper .content {
      background-size: 40% !important;
      background-position: 97% 50% !important;
    }
  }

  @media (max-width: 992px) {
    .content-wrapper .content {
      background-image: unset !important;
    }
    
    .content-wrapper .content .content-header {
      display: none !important;
    }

    .content-wrapper .content .form {
      margin-top: 20px;
      width: 100% !important;
    }
  }

  @media (max-width: 768px) {
    .content-wrapper .content {
      height: auto !important;
    }

    .help-block {
      height: auto !important;
      display: block !important;
      position: unset !important;
      top: unset;
      margin-left: 0 !important;
    }
    
    .custom-help-block-1 {
      top: unset;
    }
    .custom-help-block-2 {
      top: unset;
    }

    .content-wrapper .content .form .form-group>.input-group,
    .content-wrapper .content .form .form-group>.form-control,
    .content-wrapper .content .form .form-group .radiobox,
    .content-wrapper .content .form .form-group .btn-submit {
      margin-left: 0 !important;
      width: 100% !important;
    }
    .content-wrapper .content .form .form-group .input-group {
      display: block;
    }
    .content-wrapper .content .form .form-group .preview {
      margin-left: 0 !important;
    }
    .content-wrapper .content .form .form-group .form-control {
      display: block !important;
    }
    .form-group {
      position: unset !important;
    }
  }
  
  .content-wrapper .content {
    background: #fff;
    background-image: url(../../assets/images/apply_bg.png);
    background-size: 40%;
    background-position: 90% 50%;
    background-repeat: no-repeat;
    border: 1px solid #e1e1e1;
    height: 920px;
    padding: 0 20px;
  }
  .content-wrapper .content ul {
    display: flex;
    flex-direction: row;
    border-bottom: 2px solid #e1e1e1;
    padding: 30px 20px 20px 20px;
  }
  .content-wrapper .content ul li {
    list-style-type:none;
    margin-right: 20px;
    font-size: 18px;
    position: relative;
    color: #222;
  }
  .content-wrapper .content ul li:not(.active) {
    color: #999;
    cursor: pointer;
  }
  .content-wrapper .content ul li.active:after {
    position: absolute;
    left: 0;
    bottom: -23px;
    content: '';
    width: 100%;
    border-bottom: 4px solid #006adf;
  }
  .content-wrapper .content .content-header {
    width: calc(100% - 40px);
    margin: 20px auto;
    text-align: center;
    display: block;
    position: relative;
  }
  .content-wrapper .content .content-header img {
    width: 100%;
  }
  .content-wrapper .content .content-header .content-header_item {
    position: absolute;
    text-align: left;
    transform: scale(0.8);
    top: 6px;
  }
  .content-wrapper .content .content-header .item_1 {
    left: -3px;
  }
  .content-wrapper .content .content-header .item_2 {
    left: 300px;
  }
  .content-wrapper .content .content-header .item_3 {
    left: 560px;
  }
  .content-wrapper .content .content-header .item_4 {
    left: 820px;
  }
  .content-wrapper .content .content-header .content-header_item .content-header_item_title {
    font-weight: bold;
    font-size: 18px;
  }
  .content-wrapper .content .content-header .content-header_item .content-header_item_content {
    font-size: 14px;
  }
  .content-wrapper .content .form {
    width: 100%;
  }

  .content-wrapper .content .form .form-group>.input-group,
  .content-wrapper .content .form .form-group>.form-control,
  .content-wrapper .content .form .form-group .radiobox,
  .content-wrapper .content .form .form-group .btn-submit  {
    margin-left: 60px;
    width: 400px;
  }
  .content-wrapper .content .form .form-group .input-group {
    display: inline-table;
  }
  .content-wrapper .content .form .form-group .preview {
    margin-left: 60px;
  }
  .content-wrapper .content .form .form-group .form-control {
    display: inline-block;
  }

  .form-group .btn-submit {
    width: 100%;
    outline: none !important;
  }

  .form-group .btn-link {
    outline: none !important;
  }

  .filebtn {
    display: none;
  }

  .apply-form .form-group .radiobox {
    margin:10px 0 10px 0;
    float:none;
  }

  .apply-form .form-group .radio {
    display: inline-block;
    margin-right: 12px;
  }

  .preview {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    margin-right: 2px;
    border: #e1e1e1 solid 1px;
    /* padding: 1px; */
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA8CAIAAAB+RarbAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo0OTZCNjVBODU3NjAxMUU5ODU1QkJEOTlGNUYxNDEzOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo0OTZCNjVBOTU3NjAxMUU5ODU1QkJEOTlGNUYxNDEzOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjQ5NkI2NUE2NTc2MDExRTk4NTVCQkQ5OUY1RjE0MTM5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjQ5NkI2NUE3NTc2MDExRTk4NTVCQkQ5OUY1RjE0MTM5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+6uHNWgAAAHdJREFUeNrs2bENwDAIAEE7w7ITLEsGSBoXlgvfb3BCiILZ3eOmnnFZwMDAwMDAwMDAwMDAwMDAwMDAwMA/VZUJAwMDAwN/m7u/h0sXKCK2i/tEmdmHssPAwMDAV99hEwYGBgYGBgYGBgYGBgYGBgYGBgZe6hVgAAJd/BePr1pNAAAAAElFTkSuQmCC) -10px 0px;
  }

  .success {
    background: #fff;
    border: 1px solid #e1e1e1;
    min-height: 500px;
    padding: 20px;
    font-size: 1.2em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
  }
  .success img {
    width: 100px;
  }
  .success .success-title {
    font-size: 1.4em;
    line-height: 2;
  }
  .success .success-content {
    font-size: 1.0em;
    line-height: 2;
    max-width: 800px;
  }
  .form-group {
    position: relative;
  }
  .help-block {
    height: 20px;
    display: unset !important;
    position: absolute;
    top: 3px;
    margin-left: 10px;
  }
  .custom-help-block-1 {
    top: 30px;
  }
  .custom-help-block-2 {
    top: 15px;
  }
  .text-msg {
    color: #999;
    margin-left: 60px;
  }
  .form-text {
    margin-bottom: 5px !important;
  }
</style>